// extracted by mini-css-extract-plugin
export default {"title":"DocumentCenterPanelTitle_title__CzbvY","label__text":"DocumentCenterPanelTitle_label__text__kzfLC","label__chip":"DocumentCenterPanelTitle_label__chip__F6Y2x"};